import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle2, ArrowRight, ScanEye } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useEffect } from 'react';
import { api } from '@/lib/api';

export default function BillingReturnPage({ result }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const isSuccess = result === 'success' || params.get('status') === 'success';

  useEffect(() => {
    // Actively reconcile against Dodo Payments so /me is up-to-date even if
    // the webhook is delayed, missed, or rejected.
    if (isSuccess) {
      api.post('/billing/sync').catch(() => {});
    }
  }, [isSuccess]);

  return (
    <div className="min-h-screen bg-background flex flex-col hero-mist">
      <header className="mx-auto w-full max-w-[1240px] px-4 sm:px-6 lg:px-8 h-16 flex items-center">
        <Link to="/" className="flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-[hsl(var(--accent))] text-[hsl(var(--accent-foreground))]"><ScanEye className="h-5 w-5" /></div>
          <div className="font-display text-base font-semibold">GEOrush</div>
        </Link>
      </header>
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-md text-center">
          {isSuccess ? (
            <>
              <div className="mx-auto h-14 w-14 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center">
                <CheckCircle2 className="h-7 w-7" />
              </div>
              <h1 className="mt-4 font-display text-2xl font-semibold">Payment received</h1>
              <p className="mt-2 text-sm text-muted-foreground">Your plan will activate in a few seconds. You can start scanning right away.</p>
              <Button className="mt-6" onClick={() => navigate('/app/dashboard')} data-testid="billing-return-continue-button">
                Go to dashboard <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </>
          ) : (
            <>
              <h1 className="font-display text-2xl font-semibold">Checkout cancelled</h1>
              <p className="mt-2 text-sm text-muted-foreground">No worries — your account is unchanged. You can pick a plan whenever you’re ready.</p>
              <div className="mt-6 flex items-center justify-center gap-2">
                <Button variant="outline" onClick={() => navigate('/app/billing/upgrade')}>View plans</Button>
                <Button onClick={() => navigate('/app/dashboard')}>Continue on Free</Button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
